<template>
  <div class="h-full p-8 pt-0 w-full overflow-auto">
    <DataGetter
      @dataAvailable="
        data => {
          deals = data
          this.isLoading = false
        }
      "
      contentId="deals"
    />
    <div
      class="flex w-full justify-between items-center sticky top-0 pt-8 pb-4 z-[2] bg-[#f4f4f5]"
    >
      <div class="text-4xl title-color">Deals journaliers</div>
      <div>
        <button
          v-if="deals.length > 0"
          @click="addNewDeal"
          class="buttonComponent"
        >
          Créer un deal
        </button>
      </div>
    </div>
    <div v-if="isLoading || deals.length > 0">
      <div class="py-4"></div>
      <div class="relative">
        <div class="w-full overflow-auto">
          <div>
            <div
              class="flex items-center justify-between p-4 rounded-2xl text-sm uppercase gap-8"
            >
              <div class="flex items-center gap-4 w-[20rem] min-w-[20rem]">
                Détails Produit
              </div>

              <div class="flex gap-6 w-[5rem] min-w-[5rem]">Montant</div>
              <div class="flex gap-6 w-[5rem] min-w-[5rem]">Réduction</div>

              <!-- Price and Quantity -->
              <div class="flex gap-6 w-[5rem] min-w-[5rem]">Date début</div>

              <div class="flex gap-6 w-[5rem] min-w-[5rem]">Date fin</div>
              <!-- SKU -->
              <!-- <div class=" text-gray-700">{{ deal.sku }}</div> -->

              <!-- Actions -->
              <div
                class="flex items-center gap-2 w-[8rem] min-w-[8rem] justify-end pr-4"
              >
                Actions
              </div>
            </div>
          </div>
          <div class="flex flex-col gap-4">
            <div
              v-for="(deal, index) in isLoading ? shimmerDeals : deals"
              :key="index"
              class="flex items-center justify-between min-w-max p-4 rounded-2xl gap-8 [&>div]:relative"
              :class="{ shimmerElement: deal.shimmer }"
            >
              <div
                class="pointer-events-none !absolute min-w-8 left-0 w-full rounded-xl h-[4lh] bg-white p-"
              ></div>
              <!-- Deal Info -->
              <div class="flex items-center gap-4 w-[20rem] min-w-[20rem]">
                <img
                  v-if="deal.image || deal.images"
                  :src="deal.image || deal.images[0]"
                  class="min-w-[4rem] w-[4rem] h-[4rem] object-cover rounded-lg"
                />
                <div class="w-[16rem]">
                  <h3 class="font-semibold title-color truncate">
                    {{ deal.name }}
                  </h3>
                  <p class="truncate">
                    {{ deal.description }}
                  </p>
                </div>
              </div>

              <!-- Price and Quantity -->
              <div class="gap-6 w-[5rem] min-w-[5rem] whitespace-nowrap">
                <div class="title-color font-bold">{{ deal.discountedPrice||0 }} FCFA</div>
                <div class="line-through">{{ deal.price }} FCFA</div>
              </div>

              <!-- Price and Quantity -->
              <div class="flex gap-6 w-[5rem] min-w-[5rem]">
                <div>{{ deal.discount||0 }}%</div>
              </div>

              <!-- Price and Quantity -->
              <div class="flex gap-6 w-[5rem] min-w-[5rem]">
                {{ $Commons.timestampToDate(deal.startDate, 'DD MMM YYYY') }}
              </div>

              <!-- Price and Quantity -->
              <div class="flex gap-6 w-[5rem] min-w-[5rem]">
                {{ $Commons.timestampToDate(deal.endDate, 'DD MMM YYYY') }}
              </div>

              <!-- SKU -->
              <!-- <div class=" text-gray-700">{{ deal.sku }}</div> -->

              <!-- Actions -->
              <div
                class="flex items-center gap-2 w-[8rem] min-w-[8rem] justify-end pr-4"
              >
                <DropdownComponent
                  :selects="[
                    {
                      name: 'Editer',
                      onClick() {
                        $Events.dispatchEvent('new_deal_update_required', deal)
                      },
                    },
                    {
                      name: 'Supprimer',
                      onClick() {
                        deleteDeal(deal)
                      },
                    },
                  ]"
                  hideArrow
                  maxHeight="270px"
                  displayKey="name"
                  toLeft
                  :onSelect="
                    selected => {
                      selected.onClick()
                    }
                  "
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-6 h-6"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"
                    />
                  </svg>
                </DropdownComponent>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="h-[60vh] w-full flex-col items-center justify-center flex"
      v-else
    >
      <div class="w-1/5">
        <img src="@/assets/images/empty/hot-sale.png" alt="" />
      </div>
      <div class="py-1"></div>
      <div class="text-center">
        <div class="py-1"></div>
        <div class="text-4xl title-color font-bold">Aucun deal trouvé</div>
        <div class="py-1"></div>
        <div class="text-lg">
          Ajouter des deals et attirer plus de client
        </div>
        <div class="py-3"></div>
        <div class="flex justify-center gap-6">
          <button @click="addNewDeal" class="buttonComponent">
            Créer un Deal
          </button>
        </div>
      </div>
    </div>
    <NewDealAdderDialog />
    <DealUpdaterDialog />
    <EventListener
      :events="['deal_canceled', 'failed_to_cancel_deal']"
      @failed_to_cancele_deal="
        () => {
          $Events.dispatchEvent('toast_notification', {
            title: 'Echec d\'annulation',
            body: 'L\'annulation du deal a échoué. Veuillez réessayer',
          })
        }
      "
      @deal_canceled="
        () => {
          $Events.dispatchEvent('toast_notification', {
            title: 'Deal annulé',
            body: 'Le deal a été annulé avec succès.',
          })
        }
      "
    />
  </div>
</template>

<script>
import NewDealAdderDialog from '@/components/deal/NewDealAdderDialog.vue'
import DealUpdaterDialog from '@/components/deal/DealUpdaterDialog.vue'
import DataGetter from '@/components/utils/DataGetter.vue'
import DropdownComponent from '@/components/utils/DropdownComponent.vue'
import EventListener from '@/components/utils/EventListener.vue'

export default {
  name: 'homeComponent',
  components: {
    NewDealAdderDialog,
    DealUpdaterDialog,
    DataGetter,
    DropdownComponent,
    EventListener,
  },
  data() {
    return {
      eventsIds: [],
      deals: [],
      isLoading: true,
      shimmerDeals: [
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
      ],
      activeTab: 'home',
    }
  },
  beforeUnmount() {},
  mounted() {},
  methods: {
    addNewDeal() {
      this.$Events.dispatchEvent('new_deal_adding_required')
    },
    async deleteDeal(deal) {
      const prompt = await this.$Events.sendDataRequestResolve(
        'customPrompt',
        {
          title: `Voulez vous vraiment Supprimer la réduction pour ${deal.name} ?`,
          subTitle:
            'Vous ne pouvez plus retrouver ce deal',

          successText: 'Supprimer le deal',
          cancelText: 'Conserver le deal',
        },
        9999999999,
      )
      if (!prompt.accepted) return null
      this.$Events.dispatchEvent('deal_deletion_requested', {
        id: deal.id,
      })
    },
  },
}
</script>
